export enum ServerActionName {
    getBasket = 'getBasket',
    getDeliveryStoreCookie = 'getDeliveryStoreCookie',
    getFavoriteStore = 'getFavoriteStore',
    getIsNotifyMeEnabled = 'getIsNotifyMeEnabled',
    getProductDeliveryInfo = 'getProductDeliveryInfo',
    getNewsletterSlot = 'getNewsletterSlot',
    getPaymentMethodsServerAction = 'getPaymentMethodsServerAction',
    getProductById = 'getProductById',
    getProductSetInfo = 'getProductSetInfo',
    getProductRecommendations = 'getProductRecommendations',
    getPromotionInfoServerAction = 'getPromotionInfoServerAction',
    getPromotionInfosMapServerAction = 'getPromotionInfosMapServerAction',
    getRecommendedProducts = 'getRecommendedProducts',
    getReviews = 'getReviews',
    getProductForm = 'getProductForm',
    voteForReview = 'voteForReview',
    reportReview = 'reportReview',
    getReviewTranslation = 'getReviewTranslation',
    getContentAssetServerAction = 'getContentAssetServerAction',
    getProductStockInStore = 'getProductStockInStore',
    getSearchSuggestions = 'getSearchSuggestions',
    getStores = 'getStores',
    getSelectedStore = 'getSelectedStore',
    getUserInfo = 'getUserInfo',
    getWishlist = 'getWishlist',
    subscribeToNewsletter = 'subscribeToNewsletter',
    updateBasket = 'updateBasket',
    updateFavoriteStore = 'updateFavoriteStore',
    updateWishlist = 'updateWishlist',
    engraveValidation = 'engraveValidation',
    postRatingReviewForm = 'postRatingReviewForm',
}
